import http from '@/utils/request'
// import router from '@/router'  // 直接导入路由实.例

export const commonApi = {
    dicts: (dictType) => {
        let url = `/system/dict/data/type/${dictType}`;

        // // 直接使用router对象
        // if (router.currentRoute &&
        //     router.currentRoute.path &&
        //     router.currentRoute.path.includes('supermarket')) {
        //     url = `/system/dict/data/type/kjcg/${dictType}`;
        // }

        return http({
            url: url,
            method: 'GET',
        })
    }
}
